import {
    LOGIN,
    LOGIN_LOADING_ON,
    LOGIN_LOADING_OFF,
    GET_CURRENT_USER,
    GET_CURRENT_USER_LOADING_ON,
    GET_CURRENT_USER_LOADING_OFF,
    VERIFY_USER_CNIC
} from '../types';

const initState = {
    isAuth: false,
    authLoading: false,
    currentUserLoading: false,
    verifyData: null,
    user: null,
    role: ''
}

export default function reducer(state=initState, action) {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                isAuth: true,
                user: action.payload.user,
                role: action.payload.role,
                authLoading: false,
            }
        case LOGIN_LOADING_ON: 
            return {
                ...state,
                authLoading: true
            }
        case LOGIN_LOADING_OFF: 
            return {
                ...state,
                authLoading: false
            }
        case GET_CURRENT_USER:
            return {
                ...state,
                isAuth: true,
                user: action.payload.user,
                role: action.payload.role ? action.payload.role : '',
                currentUserLoading: false,
            }
        case GET_CURRENT_USER_LOADING_ON: 
            return {
                ...state,
                currentUserLoading: true
            }
        case GET_CURRENT_USER_LOADING_OFF: 
            return {
                ...state,
                currentUserLoading: false
            }
        case VERIFY_USER_CNIC:
            return {
                ...state,
                authLoading: false,
                verifyData: action.payload
            }

        default:
            return state;
    }
}